import FormComponent from "../../common/FormComponent";
import React from "react";
import { bindActionCreators } from "redux";
import * as Actions from "../../actions/Actions";
import { withRouter } from "react-router-dom";
import connect from "react-redux/es/connect/connect";
import Grid from "@material-ui/core/Grid";
import { Paper } from "@material-ui/core";
import strings from "../../localization";
import Validators from "../../constants/ValidatorTypes";
import { withSnackbar } from "notistack";
import CauseOfDeathForm from '../../components/forms/causeOfDeath/CauseOfDeathFrom';
import { getCauseOfDeathById, editCauseOfDeath } from "../../services/causeOfDeath/CauseOfDeathService";

class EditCauseOfDeath extends FormComponent {

  validationList = {
    // code: [{ type: Validators.REQUIRED }],
    name: [{ type: Validators.REQUIRED }],
  };

  constructor(props) {
    super(props);

    this.state = {
      data: props.data ? props.data : {},
      errors: {}
    };

    this.props.changeFullScreen(false);
    this.submit = this.submit.bind(this);
  }

  componentDidMount() {

    getCauseOfDeathById(this.props.id, this.props.auth.user.id, this.props.auth.user.company.id).then(response => {
      this.setState({
        data: response.data
      });
    });
  }

  handleChange = (event) =>{
    this.setState({
      data: {
        ...this.state.data, [event.target.name]: event.target.value
      }
    });
  }

  submit() {

    if (!this.validate()) {
      return;
    }

    this.showDrawerLoader();
    
    editCauseOfDeath(this.transformRequest(this.state.data)).then(response => {
      if (!response.ok) {
        let messageKey = response.response.data.message;

        this.props.enqueueSnackbar(strings.causeOfDeath.messages[messageKey], {
          variant: "error"
        });

        this.handleError(messageKey);

        return;
      }

      this.props.enqueueSnackbar(strings.addCompany.causeOfDeatEdited, { variant: 'success' });
      this.props.onFinish(response.data.causeOfDeath);

      this.hideDrawerLoader();
    });
  }

  transformRequest(data) {
    return {
      ...data,
      userEmail: this.props.uemail,
      companyId: this.props.cid
    }
  }

  handleError(message) {
    switch (message) {
      // case "CAUSE_OF_DEATH_WITH_CODE_ALREADY_EXIST":
      //   this.setError("code", strings.causeOfDeath.messages.CAUSE_OF_DEATH_WITH_CODE_ALREADY_EXIST);
      //   break;
      // case "CAUSE_OF_DEATH_CODE_CANT_BE_NULL":
      //   this.setError("code", strings.causeOfDeath.messages.CAUSE_OF_DEATH_CODE_CANT_BE_NULL);
      //   break;

      case "CAUSE_OF_DEATH_WITH_NAME_ALREADY_EXIST":
        this.setError("name", strings.causeOfDeath.messages.CAUSE_OF_DEATH_WITH_NAME_ALREADY_EXIST);
        break;
      case "CAUSE_OF_DEATH_NAME_CANT_BE_NULL":
        this.setError("name", strings.causeOfDeath.messages.CAUSE_OF_DEATH_NAME_CANT_BE_NULL);
        break;
    }
  }

  render() {
    return (
      <Grid id="page" item md={12}>
        <div className="header">
          <h1>{strings.causeOfDeath.editPageTitle}</h1>
        </div>

        <Paper className="paper">
          <CauseOfDeathForm
            onChange={this.changeData}
            onSubmit={this.submit}
            handleChange={this.handleChange}
            data={this.state.data}
            errors={this.state.errors}
            onCancel={this.props.onCancel}
          />
        </Paper>

      </Grid>
    );
  }
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      changeFullScreen: Actions.changeFullScreen
    },
    dispatch
  );
}

function mapStateToProps({ menuReducers, siteDataReducers }) {
  return { menu: menuReducers, siteData: siteDataReducers };
}

export default withSnackbar(
  withRouter(
    connect(
      mapStateToProps,
      mapDispatchToProps
    )(EditCauseOfDeath)
  )
);
